import React from 'react';
var Highcharts = require('highcharts');

export default class Weekdays extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    componentDidUpdate() {
        this.renderChart();
    }

    componentDidMount() {
        this.renderChart();
    }

    renderChart() {
        Highcharts.chart("weekday_container",
            {
                chart: {
                    type: "area"
                },

                title: {
                    text: null
                },

                xAxis: {
                    tickLength: 5,
                    tickWidth: 0.3,
                    lineWidth: 0.3,
                    categories: this.props.weekdays.map((x) => { return x.day; }),
                    labels: {
                        autoRotation: false,
                        style: { fontSize: '9px' }
                    }

                },

                yAxis: {
                    title: {
                        text: this.props.dataType,
                        style: { fontSize: '12px' },
                    },
                    labels: {
                        formatter: function () {
                            return this.value
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                        },
                        style: { fontSize: '9px' }
                    },
                    min: Math.min.apply(Math, this.props.weekdays.map((x) => {
                        return Math.min(x.delivered, x.target);
                    })) * 0.75
                },
                legend: {
                    enabled: false
                },

                credits: false,

                plotOptions: {
                    series: {
                        enableMouseTracking: true,
                        dataLabels: {
                            enabled: true,
                            overflow: "allow",
                            crop: false,
                            style: {
                                fontWeight: "normal",
                                fontSize: '9px'
                            },
                            formatter: function () {
                                return this.y
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                            },
                        }
                    },
                    area: {
                        fillOpacity: 1,
                        marker: {
                            enabled: false
                        }
                    }
                },

                legend: {
                    layout: 'horizontal',
                    align: 'right',
                    verticalAlign: 'top',
                    x: 0,
                    y: 0,
                    floating: true,
                    enabled: this.props.showTarget
                },

                tooltip: {
                    formatter: function () {
                        const header = `${this.key}<br/>`;
                        const body = `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}</b>`;
                        return header + body;
                    },
                    style: {
                        fontSize: '12px'
                    }
                },

                series: [
                {
                    name: "Delivered",
                    color: this.props.color1,
                    type: "column",
                    data: this.props.weekdays.map((x) => { return x.delivered; })
                }
                ].concat(this.props.showTarget ? {
                    name: "Target",
                    color: this.props.color2,
                    type: "area",
                    data: this.props.weekdays.map((x) => { return x.target; }),
                } : []).reverse()
            });
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <h4>Weekday</h4>
                </div>
                <div className="col-md-12">
                    <div id="weekday_container"></div>
                </div>
            </div>
        );
    }
}